'use strict';

/* eslint-disable func-style */
/* eslint-disable max-lines-per-function */
export default function () {
	$('.js-tabs').each(function () {
		if ($(this).hasClass('js-tabs--initalized')) {
			return;
		}

		$(this).addClass('js-tabs--initalized');
		var $container = $(this);

		$container.find('.tab').each(function (index) {
			var tabItem = $(this).parents('.js-tabs').find('.js-tab-item:eq(' + index + ')');
			var tabLabel = $(this).text();
			var tabClasses = 'accordion-tab';

			if (tabItem.hasClass('active')) {
				tabClasses += ' tab-active accordion-active';
			}

			$('<div class="' + tabClasses + '">' + tabLabel + '</div>').insertBefore(tabItem);
		});

		$(this).on('click', '.js-tab', function (e) {
			e.preventDefault();
			var $tab = $(this),
				index = $tab.index(),
				$container = $tab.closest('.js-tabs'),
				$tabItem = $container.find('.tab-item:eq(' + index + '), .js-tab-item:eq(' + index + ')');
	
	
			if ($tabItem.is(':visible')) {
				return false;
			}
	
			$container.find('.tab-active').removeClass('tab-active');
			$container.find('.tab-item, .js-tab-item').removeClass('active');
			$tabItem.addClass('active');
			$tab.addClass('tab-active');
	
			return true;
		});

		$(this).on('click', '.accordion-tab', function (e) {
			e.preventDefault();
			var $tab = $(this),
				index = $tab.index(),
				$container = $tab.closest('.js-tabs'),
				$tabItem = $(this).next('.tab-item');
	
	
			if ($tabItem.is(':visible')) {
				$tabItem.removeClass('active');
				$tab.removeClass('accordion-active');
				return false;
			}
	
			$container.find('.accordion-active').removeClass('accordion-active');
			$container.find('.tab-item, .js-tab-item').removeClass('active');
			$tabItem.addClass('active');
			$tab.addClass('accordion-active');
	
			scrollToDiv($('.accordion-active'), 50);
	
		});
	});

};
